import React, { FC, useRef, useEffect, useState, memo } from 'react';
import { StatusTip } from 'tea-component';
import GameImage from '@/pages/home/components/GameImage';
import classnames from 'classnames';
import { newMathFormat } from '@/pages/intelligence/utils/commonUtils';
import { getDetailGamePathCommon } from '@/pages/intelligence/utils/topchartsUtils';
import { history } from 'umi';

const { LoadingTip } = StatusTip;

import './RetentionTopList.scss';
import SvgIcon from '@/pages/home/components/SvgIcon';

interface RetentionTopListProp {
  gameTopList: any[];
  loading: boolean;
}

const RetentionTopList: FC<RetentionTopListProp> = (props) => {
  const { gameTopList, loading } = props;

  const handleClickPlatGoDetail = (
    cvm: any,
    needPath = false,
    plat?: string,
  ) => {
    const type = plat ? plat : cvm?.platform?.[0] || 'pc';
    const app_id = cvm?.[`${type}_id`] || cvm?.app_id;
    const pathname = getDetailGamePathCommon({
      entityType: type,
      gameId: app_id,
      tab: 'stats',
      subTab: type === 'pc' ? 'pcu' : 'digitalrevenue',
    });
    if (needPath) {
      return pathname;
    } else {
      history.push({
        pathname,
      });
    }
  };

  return (
    <div className="dbi-benckmark-topgame">
      {loading ? (
        <div className="dbi-benckmark-topgame-loading">
          <LoadingTip className="dbi-benchmark-chart-loading" />
        </div>
      ) : (
        <>
          {gameTopList?.length > 0 ? (
            gameTopList?.map((item, index) => (
              <div className="dbi-benckmark-topgame-item" key={index}>
                <span
                  className="dbi-benckmark-topgame-item-header"
                  onClick={() => {
                    handleClickPlatGoDetail(item);
                  }}
                >
                  <GameImage src={item?.cover} />
                </span>
                <div className="dbi-benckmark-topgame-item-content">
                  <div className="game-title">
                    <span className="game-title-left">
                      <a
                        href={handleClickPlatGoDetail(item, true)}
                        target="_blank"
                      >
                        {item?.name}
                      </a>
                      {item?.platform?.map((plat: string) => (
                        <a
                          className="benchmark-plat-alink"
                          key={plat}
                          target="_blank"
                          href={handleClickPlatGoDetail(item, true, plat)}
                        >
                          <SvgIcon
                            className="benchmark-gametype-icon"
                            type={plat === 'pc' ? 'monitor' : 'game'}
                          />
                        </a>
                      ))}
                    </span>

                    <span
                      className={classnames([
                        'game-title-right',
                        {
                          'active-title': index <= 2,
                        },
                      ])}
                    >
                      {newMathFormat(item?.metric_value, true)}
                    </span>
                  </div>
                  <div className="game-progress">
                    <div
                      className="game-progress-block"
                      style={{
                        backgroundColor: index <= 2 ? '#5086F3' : '#ACB5D4',
                        width: `${(
                          (item?.metric_value / gameTopList[0]?.metric_value) *
                          0.9 *
                          100
                        )?.toFixed(2)}%`,
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="dbi-benckmark-topgame-loading">
              No data under current filter selections.
            </div>
          )}
        </>
      )}
    </div>
  );
};

RetentionTopList.defaultProps = {
  gameTopList: [],
};

export default RetentionTopList;
